const FAKE_NAMES: { [name: string]: string } = {
  "0001": "John Doe",
  "0002": "Jane Smith",
  "0003": "Alice Johnson",
  "0004": "Bob Brown",
  "0005": "Charlie Davis",
  "0006": "Diana Evans",
  "0007": "Ethan Foster",
  "0008": "Fiona Green",
  "0009": "George Harris",
  "0010": "Hannah Ives",
  "0011": "Ian Jones",
  "0012": "Julia King",
  "0013": "Kevin Lee",
  "0014": "Laura Miller",
  "0015": "Michael Nelson",
};

export function generateDummyCostData(quantity: number = 15) {
  const costCentreCodes = [...Array(quantity).keys()].map((value) =>
    value.toString().padStart(4, "0"),
  );

  const costCentres = Object.fromEntries(
    costCentreCodes.map((costCentreCode) => [
      costCentreCode,
      {
        code: costCentreCode,
        name: `Cost Centre ${costCentreCode}`,
        owner: FAKE_NAMES[costCentreCode],
        present_in_final_month: true,
      },
    ]),
  );

  return {
    cost_centres: costCentres,
    months: [
      {
        is_current_month: false,
        is_invoicing_finalised: true,
        costs: {},
        month: "2000-01-01",
        total: "0",
      },
      {
        is_current_month: false,
        is_invoicing_finalised: true,
        costs: {},
        month: "1999-12-01",
        total: "0",
      },
    ],
    last_updated: "2000-01-01",
  };
}
